import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D277 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">You're viewing D277 - Front-End Web Development</h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 5.43 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            This course was so easy and also fun. This is when we get to code
            for the first time. There are two tasks to submit. The first one is
            a layout diagram of your website. I created two pages: 1. A home
            page layout, and 2. A city page layout. I made them on Canva. You
            can open Canva, start a new project with a blank canvas in computer
            screen size, and then just drag and color rectangles, etc. Make sure
            you mark the semantic element tags. Remember, it's just a layout, so
            if there's an image that needs to go somewhere on the page, simply
            add a “Image Here” rectangle or use an "X" wireframe to show that
            the space is reserved for the image.
          </p>
          <p>
            For task 2, it’s basic coding. Use ChatGPT as your study buddy. For
            example, if I needed CSS to align something in the center, I would
            just ask ChatGPT and request an explanation. The best part about
            ChatGPT is that if you don’t understand it, you can ask it to
            explain it in simpler and simpler terms until it clicks. It’s super
            helpful. This is what I meant earlier when I said CSS should be
            learned along the way. Once the files were ready, I hosted them on
            Netlify — super easy and free.
          </p>
          <p>
          Take a look at this, its pretty helpful: <a href="https://www.w3schools.com/html/html5_semantic_elements.asp " target="_blank" rel="noreferrer">W3Schools Semantic Elements</a>
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};
export default D277;
